import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";
import { useIsTouch } from "./motion";

// CAD-style crosshair cursor with live coordinates. Desktop (fine pointer) only.
export const Cursor = () => {
  const touch = useIsTouch();
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 900, damping: 60, mass: 0.2 });
  const sy = useSpring(y, { stiffness: 900, damping: 60, mass: 0.2 });
  const [hover, setHover] = useState(false);
  const [coords, setCoords] = useState("");

  useEffect(() => {
    if (touch) return;
    const move = (e) => {
      x.set(e.clientX); y.set(e.clientY);
      setCoords(`${String(Math.round(e.clientX)).padStart(4, "0")} · ${String(Math.round(e.clientY)).padStart(4, "0")}`);
      setHover(!!e.target.closest?.("a, button, [role=button], input, textarea, select"));
    };
    window.addEventListener("pointermove", move, { passive: true });
    return () => window.removeEventListener("pointermove", move);
  }, [touch, x, y]);

  if (touch) return null;
  const size = hover ? 36 : 12;
  return (
    <div className="pointer-events-none fixed inset-0 z-[70] hidden md:block mix-blend-difference" aria-hidden="true" data-testid="cad-cursor">
      <motion.div className="absolute top-0 bottom-0 w-px bg-white/40" style={{ x: sx }} />
      <motion.div className="absolute left-0 right-0 h-px bg-white/40" style={{ y: sy }} />
      <motion.div
        className="absolute border border-white"
        style={{ x: sx, y: sy }}
        animate={{ width: size, height: size, marginLeft: -size / 2, marginTop: -size / 2, borderRadius: hover ? 999 : 0 }}
        transition={{ type: "spring", stiffness: 400, damping: 30 }}
      />
      {coords && (
        <motion.span className="absolute ml-4 mt-3 font-mono text-[10px] tracking-[0.2em] text-white/70 whitespace-nowrap" style={{ x: sx, y: sy }}>
          {coords}
        </motion.span>
      )}
    </div>
  );
};
